<template>
  <div>
    <assistant-message
      v-if="isAI"
      :message="message"
      :animate="animate"
      :streaming-active="streamingActive"
      :is-last-message="isLastMessage"
      @content-rendered="$emit('content-rendered')"
      @rerun-prompt="$emit('rerun-prompt', $event)"
      @suggestion-select="$emit('suggestion-select', $event)"
    />

    <user-message
      v-else
      :message="message"
      :show-edit-button="showEditButton"
      :streaming-active="streamingActive"
      :is-editing="isEditing"
      @edit-prompt="$emit('edit-prompt', $event)"
      @cancel-edit-prompt="$emit('cancel-edit-prompt')"
      @submit-edit-prompt="$emit('submit-edit-prompt', $event)"
    />
  </div>
</template>

<script>
import UserMessage from './UserMessage.vue'
import AssistantMessage from './AssistantMessage.vue'

export default {
  name: 'ChatMessage',

  components: {
    UserMessage,
    AssistantMessage
  },

  props: {
    message: {
      type    : Object,
      required: true
    },
    animate: {
      type   : Boolean,
      default: false
    },
    showEditButton: {
      type   : Boolean,
      default: false
    },
    streamingActive: {
      type   : Boolean,
      default: false
    },
    isEditing: {
      type   : Boolean,
      default: false
    },
    isLastMessage: {
      type   : Boolean,
      default: false
    }
  },

  computed: {
    isAI () {
      return this.message?.role === 'AI'
    }
  }
}
</script>
